/**
 * Resolve article code (business SKU) from a product or line-item shaped object.
 * Returns null when no code is available so callers can omit the field safely.
 *
 * @param {object | null | undefined} item
 * @returns {string | null}
 */
export function getArticleCode(item) {
  if (!item) return null
  const code =
    item.article_code ??
    item.product?.article_code ??
    item.sku ??
    item.product?.sku ??
    ''
  const trimmed = String(code).trim()
  return trimmed || null
}

/**
 * Resolve article code using direct fields first, then matching order line items.
 *
 * @param {object | null | undefined} item
 * @param {Array<object> | null | undefined} lineItems
 * @returns {string | null}
 */
export function getArticleCodeWithLineItems(item, lineItems) {
  const direct = getArticleCode(item)
  if (direct) return direct
  if (!item || !Array.isArray(lineItems)) return null

  if (item.order_line_item_id != null) {
    const byLineId = lineItems.find(
      (li) => li.id === item.order_line_item_id || li.order_line_item_id === item.order_line_item_id,
    )
    const fromLine = getArticleCode(byLineId)
    if (fromLine) return fromLine
  }

  if (item.product_id != null) {
    const byProductId = lineItems.find((li) => {
      const adminProductId =
        li?.meta?.admin_product_id ?? li?.admin_product_id ?? li?.product_id
      return adminProductId === item.product_id
    })
    return getArticleCode(byProductId)
  }

  return null
}
